  /**
   * RMKM new Implement 
   * @addedBy jaseem-hussain
   * date : 30 December 2025
   * Add new Component
   *  */
import React, { useEffect, useState } from "react";
import { Button, Col, Row, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import inventoryApi from "../api/inventoryApi";

import {
  DatatableWrapper,
  Filter,
  Pagination,
 
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import { Link } from "react-router-dom";

const PhysioAssesmentList = () => {
  const navigate = useNavigate();
  const [body, setBody] = useState([]);
  useEffect(() => {
    fetchAssessments();

    // let temp = [{
    //   "id" : "1234",
    //   "name" : "Test",
    //   "period" :"JAN to JUNE",
    //   "index" : "1"
    // }]

    // setBody(temp);
  }, []);

  const fetchAssessments = async(e) => {
    const result = await inventoryApi.fetchStudents();
    if (result) {
      console.log('result ======>', result)
      //let tempBody = result.map((data, index) => ({ ...data, index: index + 1 }));
      setBody(result);
    } else {
        setBody([]);
    }
  }

    const handlePhysiotherepy = (student) => {
    async function initStudent() {
      let result = await inventoryApi.fetchStudentPhysioAssessment(student);
      //console.log('physioAssessment', result)
      if (result && result.id) {
        navigate(`/student/physioassessment/${result.id}`, { state: result })

      }
      else {
        navigate(`/student/${student.id}/physioassessment`, { state: student })
      }
    }
    initStudent();
  }
  
  // Create table headers consisting of 4 columns.
  const header = [
    {
      title: "Name",
      prop: "name",
      isFilterable: true,
      cell: (row) => (
        <span
          style={{
            color:"#1e96f3ff", 
            // "#1180D3",
            cursor: "pointer",
            // textDecoration: "underline",
          }}
          onClick={() => handlePhysiotherepy(row)}
        >
         <b>{row.name}</b> 
        </span>
      ),
    },

    { title: "Father Name", prop: "fathername", isFilterable: true },
    {
      title: "Child Registration Age",
      prop: "childregistrationage",
      isFilterable: true,
    },
    { title: "Child Current Age", prop: "child_age", isFilterable: true },
    {
      title: "Service Category",
      prop: "servicecategoryname",
      isFilterable: true,
    },
  ];

  // Randomize data of the table columns.
  // Note that the fields are all using the `prop` field of the headers.
 



  // const createAssessment = () => {
  //   navigate(`/assessments/e`);
  // };

  return (
    <Row className="g-0">
      <Col lg={2} className="mx-2">
      <Link className="nav-link">
            Home <i className="fa-solid fa-chevron-right"></i> Physiotherapy
          </Link>
      </Col>

      <Col lg={12} className="p-lg-4">
        <DatatableWrapper
          body={body}
          headers={header}
          paginationOptionsProps={{
            initialState: {
              rowsPerPage: 20,
              options: [5, 10, 15, 20],
            },
          }}
        >
          <Row className="mb-4">
            <Col
              xs={12}
              lg={4}
              className="d-flex flex-col justify-content-end align-items-end"
            >
              <Filter />
            </Col>
            <Col
              xs={12}
              sm={6}
              lg={4}
              className="d-flex flex-col justify-content-start align-items-start"
            >
            </Col>
            <Col
              xs={12}
              sm={6}
              lg={4}
              className="d-flex flex-col justify-content-end align-items-end"
            >
              {/* <Button
                className="btn-sm"
                variant="outline-primary"
                onClick={() => createAssessment(true)}
              >
                Create Assessment
              </Button> */}
            </Col>
          </Row>
          {/*  {body.length>0 ? */}
          <Table striped className="data-table">
            <TableHeader />
            <TableBody />
          </Table>
          {/* :
             ""} */}
          <Pagination />
        </DatatableWrapper>
      </Col>
      <Col lg={2}></Col>
    </Row>
  );
};

export default PhysioAssesmentList;